<template>
  <div class="business-view-detail">
    <HeaderWithFilter
        :showFilter="true"
        :go-back="goToDashboard"
        :has-prev="true"
        :is-top-bv="true"
        title="Business View"
    />

    <div class="content-wrapper">
      <div class="metrics-charts">
        <section class="metrics-summary">
          <MetricCard
              title="Omzet"
              :amount="financialResponse.financialData?.[0]?.totalRevenue??0"
              :change="(((financialResponse.financialData?.[0]?.totalRevenue??0)-(financialResponse.financialData?.[1]?.totalRevenue??0))*100/(financialResponse.financialData?.[1]?.totalRevenue??1)).toFixFloat(2)"
              iconSrc="/assets/bv_deposit.svg"
          />
          <MetricCard
              title="Kosten"
              :amount="financialResponse.financialData?.[0]?.reportExpenses??0"
              :change="((((financialResponse.financialData?.[1]?.reportExpenses??0)-(financialResponse.financialData?.[0]?.reportExpenses??0))*100)/(financialResponse.financialData?.[1]?.reportExpenses??1)).toFixFloat(2)"
              iconSrc="/assets/bv_withdraw.svg"
          />
          <MetricCard
              title="Winst/Verlies"
              :amount="financialResponse.financialData?.[0]?.profitReport??0"
              :change="((((financialResponse.financialData?.[0]?.profitReport??0)-(financialResponse.financialData?.[1]?.profitReport??0))*100)/(financialResponse.financialData?.[1]?.profitReport??1)).toFixFloat(2)"
              iconSrc="/assets/bv_profit_loss.svg"
          />
          <MetricCardSimple
              title="Aantal vervoersopdrachten"
              :amount="financialResponse.totalRows"
              iconSrc="/assets/supply.svg"
          />
        </section>

        <section class="chart-section">
          <RevenueChart/>
        </section>
      </div>
    </div>

    <DashboardBVHeader @search="handleSearch" title="Vervoersopdrachten" :is-main='true' class="mt-8"/>
    <DashboardBVHeader title="Vervoersopdrachten met meeste omzet" :is-main='false' class="mt-8"/>

    <section class="bv-section">
      <div class="">
        <div class="cd-section">
          <Carousel
              @slide-end="onSlideOzmet"
              ref="myCarouselOzmet"
              v-model="currentSlideOzmet"
              :items-to-show="itemsToShow"
              :wrapAround="false"
              :vertical="false"
              :snap-align="'start'"
              :transition="1000"
              class="company-views-carousel"
          >
            <Slide class="grid-container" v-for="(bv, index) in filteredCards"
                   :style="{ marginLeft: index === 0 ? '16px' : '0' }">
              <div class="mr-5">
                <DashboardBvCard
                    :costs-percentage-change="bv.changeCost??0"
                    :profit-percentage-change="bv.changeProfit??0"
                    :revenue-percentage-change="bv.changeRevenue??0"
                    :profit-loss="bv.profitLatest??0"
                    :costs="bv.costLatest??0"
                    :revenue="bv.revenueLatest??0"
                    :have-detail="false"
                    :name="bv.title"/>
              </div>
            </Slide>
          </Carousel>

        </div>
        <!--        <PaginationControls
                    v-if="totalPagesOzmet>0"
                    @update:modelValue="changePageOzmet"
                    :page-change="changePageOzmet"
                    v-model="currentPageOzmet"
                    :totalPages="totalPagesOzmet"
                />-->
      </div>
    </section>
    <DashboardBVHeader title="Vervoersopdrachten met meeste kosten" :is-main='false' class="mt-8"/>

    <section class="bv-section">
      <div class="">
        <div class="cd-section">
          <Carousel
              @slide-end="onSlideWinst"
              ref="myCarouselWinst"
              v-model="currentSlideWinst"
              :items-to-show="itemsToShow"
              :wrapAround="false"
              :vertical="false"
              :snap-align="'start'"
              :transition="1000"
              class="company-views-carousel"
          >
            <Slide class="grid-container" v-for="(bv, index) in filteredCardsKosten"
                   :style="{ marginLeft: index === 0 ? '16px' : '0' }">
              <div class="mr-5">
                <DashboardBvCard
                    :costs-percentage-change="bv.changeCost??0"
                    :profit-percentage-change="bv.changeProfit??0"
                    :revenue-percentage-change="bv.changeRevenue??0"
                    :profit-loss="bv.profitLatest??0"
                    :costs="bv.costLatest??0"
                    :revenue="bv.revenueLatest??0"
                    :have-detail="false"
                    :name="bv.title"/>
              </div>
            </Slide>
          </Carousel>

        </div>
        <!--            <PaginationControls
                        @update:modelValue="changePageWinst"
                        :page-change="changePageWinst"
                        v-model="currentPageWinst"
                        :totalPages="totalPagesWinst"
                    />-->
      </div>
    </section>
    <DashboardBVHeader title="Vervoersopdrachten met meeste winst/verlies" :is-main='false' class="mt-8"/>

    <section class="bv-section">
      <div class="">
        <div class="cd-section">
          <Carousel
              @slide-end="onSlideVerlies"
              ref="myCarouselVerlies"
              v-model="currentSlideVerlies"
              :items-to-show="itemsToShow"
              :wrapAround="false"
              :vertical="false"
              :snap-align="'start'"
              :transition="1000"
              class="company-views-carousel"
          >
            <Slide class="grid-container" v-for="(bv, index) in filteredCardsWinst"
                   :style="{ marginLeft: index === 0 ? '16px' : '0' }">
              <div class="mr-5">
                <DashboardBvCard
                    :costs-percentage-change="bv.changeCost??0"
                    :profit-percentage-change="bv.changeProfit??0"
                    :revenue-percentage-change="bv.changeRevenue??0"
                    :profit-loss="bv.profitLatest??0"
                    :costs="bv.costLatest??0"
                    :revenue="bv.revenueLatest??0"
                    :have-detail="false"
                    :name="bv.title"/>
              </div>
            </Slide>
          </Carousel>

        </div>
        <!--            <PaginationControls
                        @update:modelValue="changePageVerlies"
                        :page-change="changePageVerlies"
                        v-model="currentPageVerlies"
                        :totalPages="totalPagesVerlies"
                    />-->
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import MetricCard from './cards/MetricCard.vue'
import MetricCardSimple from './cards/MetricCardSimple.vue'
import RevenueChart from './charts/RevenueChart.vue'
import {financialResponse} from "../composables/getFinancial";
import PaginationControls from './PaginationControls.vue'
import DashboardBVHeader from './DashboardBVHeader.vue'
import {type BusinessView} from './types'
import {Carousel, type CarouselMethods, Slide} from "vue3-carousel";
import DashboardBvCard from "../components/cards/DashboardBvCard.vue";
import {computed, onMounted, onUnmounted, ref, watch} from "vue";
import router from '../router'
import HeaderWithFilter from "../components/HeaderWithFilter.vue";

const searchQuery = ref('')

const changePageOzmet = (page: number) => {
  console.log("page changed to " + page)
  const filteredCardsLength = filteredCards.value.length;
  console.log('Length of filteredCards:', filteredCardsLength);
  myCarouselOzmet?.value?.slideTo(itemsToShow.value * (page - 1));
  currentPageOzmet.value = page
  totalPagesOzmet.value = Math.ceil((filteredCards.value?.length ?? financialResponse.value.cards.length ?? 0) / itemsToShow.value)
  console.log("items per page: " + itemsToShow.value)
  console.log("total pages: " + totalPagesOzmet.value)
  console.log("total pages: " + Math.ceil((filteredCards.value?.length ?? financialResponse.value.cards.length ?? 0) / itemsToShow.value))
  console.log("total items: " + filteredCards.value?.length ?? financialResponse.value.cards.length ?? 0)
}

Number.prototype.toFixFloat = function (decimalPlaces) {
  return Math.round(this * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
};
const myCarouselOzmet = ref<CarouselMethods>();
const itemsToShow = ref(1);
watch(financialResponse, (newVal) => {
  searchQuery.value = ''
  totalPagesOzmet.value = Math.ceil((financialResponse.value.cards.length ?? 0) / itemsToShow.value)
});
const handleSearch = (query: string) => {
  searchQuery.value = query
}
const updateItemsToShow = () => {
  const containerWidth =
      document.querySelector('.company-views-carousel')?.clientWidth || 0;
  console.log(containerWidth)
  const itemWidth = 260; // Fixed item width
  itemsToShow.value = Math.floor(containerWidth / itemWidth);
  totalPagesOzmet.value = Math.ceil((filteredCards?.length ?? 0) / itemsToShow.value)
  // totalPagesVerlies = Math.ceil(businessViewsVerlies.length / itemsToShow.value)
  // totalPagesWinst = Math.ceil(businessViewsWinst.length / itemsToShow.value)
};
const filteredCards = computed(() => {
  const query = searchQuery.value.toLowerCase()
  let cards = financialResponse.value.cards?.filter(card =>
      card.title?.toLowerCase().includes(query)
  )
  cards.sort((a, b) => {
    return (b.revenueLatest ?? 0) - (a.revenueLatest ?? 0)
  })
  totalPagesOzmet.value = Math.ceil((cards?.length ?? 0) / itemsToShow.value)
  return cards || [];
})
const filteredCardsWinst = computed(() => {
  const query = searchQuery.value.toLowerCase()
  let cards = financialResponse.value.cards?.filter(card =>
      card.title?.toLowerCase().includes(query)
  )
  cards.sort((a, b) => {
    return (b.profitLatest ?? 0) - (a.profitLatest ?? 0)
  })
  totalPagesOzmet.value = Math.ceil((cards?.length ?? 0) / itemsToShow.value)
  return cards || [];
})
const filteredCardsKosten = computed(() => {
  const query = searchQuery.value.toLowerCase()
  let cards = financialResponse.value.cards?.filter(card =>
      card.title?.toLowerCase().includes(query)
  )
  cards.sort((a, b) => {
    return (b.costLatest ?? 0) - (a.costLatest ?? 0)
  })
  totalPagesOzmet.value = Math.ceil((cards?.length ?? 0) / itemsToShow.value)
  return cards || [];
})

// Update on window resize
onMounted(() => {
  updateItemsToShow();
  window.addEventListener('resize', updateItemsToShow);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateItemsToShow);
});
let currentPageOzmet = ref(1)
let currentPageVerlies = ref(1)
let currentPageWinst = ref(1)

const onSlideOzmet = (value: any) => {
  currentPageOzmet.value = Math.floor(value.currentSlideIndex / itemsToShow.value) + 1
};
const onSlideVerlies = (value: any) => {
  currentPageVerlies.value = Math.floor(value.currentSlideIndex / itemsToShow.value) + 1
};
const onSlideWinst = (value: any) => {
  currentPageWinst.value = Math.floor(value.currentSlideIndex / itemsToShow.value) + 1
};
let currentSlideOzmet = 0
let currentSlideWinst = 0
let currentSlideVerlies = 0

let totalPagesOzmet = ref(Math.ceil((financialResponse.value.cards?.length ?? 0) / itemsToShow.value))

const goToDashboard = () => {
  router.push({name: "home"})
}
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Two items per row */
  gap: 16px; /* Adjust the space between grid items */
}

.grid-item {
  background: lightgray; /* Optional: Style the grid items */
  border-radius: 8px;
}

.cd-section {
  width: 90vw;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
}

.company-views-carousel {
  text-align: start;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.business-view-detail {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-top: 24px;
  width: 100%;
}

.header {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
}

.icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.business-name {
  color: var(--Neutral-5, #191a1f);
  font: 500 20px Montserrat, sans-serif;
  margin: 0;
}

.status-badge {
  border-radius: 24px;
  background: var(--Primary-light-1, #c9dafd);
  color: var(--Primary-Primary, #080aed);
  padding: 4px 8px;
  font: 600 10px/1.6 Montserrat, sans-serif;
}

.date-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  min-width: 240px;
}

.time-selector {
  display: flex;
  gap: 8px;
  background: var(--Neutral-6, #c7c8cc);
  border-radius: 8px;
  padding: 4px;
}

.time-option {
  border: none;
  background: none;
  color: var(--Neutral-8, #595c69);
  padding: 4px 16px;
  border-radius: 6px;
  font: 500 12px/1 Montserrat, sans-serif;
  cursor: pointer;
}

.time-option.active {
  background: var(--Neutral-background, #f7f8fc);
  color: var(--Neutral-5, #191a1f);
}

.filter-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid var(--Neutral-7, #787a87);
  border-radius: 8px;
  background: none;
  cursor: pointer;
  padding: 4px;
}

.filter-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.content-wrapper {
  margin-top: 16px;
  margin-bottom: 16px;
}

.metrics-charts {
  display: flex;
  gap: 20px;
}

.metrics-summary {
  width: 27%;
  display: flex;
  margin-right: 40px;
  flex-direction: column;
  gap: 8px;
}

.chart-section {
  width: 70vw;
  display: flex;
  align-items: flex-end; /* Align child elements to the bottom */
}

.contracts-title {
  color: var(--Neutral-5, #191a1f);
  font: 500 20px Montserrat, sans-serif;
  margin: 0 0 16px;
}

.contracts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

@media (max-width: 991px) {
  .business-view-detail {
    max-width: 100%;
  }

  .metrics-charts {
    flex-direction: column;
  }

  .metrics-summary,
  .chart-section {
    width: 100%;
  }

  .contracts-grid {
    width: 90%;
    grid-template-columns: 1fr;
  }
}
</style>